import React, { useEffect, useState } from 'react'
import ContactService from '../../services/contact.service';

const DetailSideForm = () => {
    const initialState={
        name:"",
        phone:"",
        email:"",
        course:"",
        message:"",
    };
 const [formData,setFormData]=useState(initialState);
 const [loading,setLoading]=useState(false);

 const handleChange=(e)=>{
    const {name,value}=e.target;
    setFormData(prev=>({...prev,[name]:value}))
 };
  
 const handleSubmit=async (e)=>{
    e.preventDefault();
    try {
        setLoading(true);
        const res=  await ContactService.save(formData);
        console.log("fardeen",res);
        if(res.success){
            alert("Data saved successfully");
            setFormData(initialState);
        }
        
    } catch (error) {
        alert(error.message);
        throw new Error(error.message);
    }finally{
        setLoading(false);
    }

 }


  return (
   <>
   <div className='shadow p-3 rounded-3 pb-5'>
    <h4 className='text-black fw-bold'>Apply for Courses</h4>
    <form>
        <div className='mb-3'>
            <label className='form-label fw-bold'>Name</label>
            <input type='text' name='name' placeholder='Name' value={formData.name} onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className='form-control' required/>
        </div>
        <div className='mb-3'>
            <label className='form-label fw-bold'>Phone No.</label>
            <input type='text' name='phone' placeholder='Phone' value={formData.phone} onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className='form-control' required/>
        </div>      
         <div className='mb-3'>
            <label className='form-label fw-bold'>Email</label>
            <input type='text' name='email' placeholder='Email' value={formData.email} onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className='form-control' required/>
        </div>
        <div className='mb-3'>
            <label className='form-label fw-bold'>Course Name</label>
            <input type='text' name='course' placeholder='Course Name' value={formData.course} onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className='form-control' required/>
        </div>
        <div className='mb-3'>
            <label className='form-label fw-bold'>Message</label>
            <textarea name='message' style={{backgroundColor:"#ECECEC"}} value={formData.message} onChange={handleChange} className='form-control px-4 py-3' rows={8} placeholder='Message' required></textarea>
        </div>
    </form>
    <button style={{backgroundColor:"#3D95CA"}} onClick={handleSubmit} type='submit' className='btn btn-primary w-100 mt-3 border-0 py-2'>{loading ? <div className='spinner-border spinner-border-sm'><div className='visually-hidden'>loading...</div></div> :"Apply Now"}</button>

   </div>
   </>
  )
}

export default DetailSideForm